<script lang="ts" setup>
import { computed } from 'vue';
import { JobLocationContext } from '@factoryfixinc/ats-interfaces';

import ArrowNarrowRightIcon from '@/assets/svg/arrow-narrow-right.svg?component';

const props = defineProps<{
  locationContext: JobLocationContext | null;
  city: string | null;
  state: string | null;
  radiusMiles: number;
}>();

// Matches the offset FormSection uses when a "Continue" button navigates between sections.
const SECTION_SCROLL_OFFSET = 64;
const DESCRIBE_THE_ROLE_SECTION_ID = 'job-details';

const scopeDetail = computed(() => {
  if (props.locationContext === JobLocationContext.NATIONWIDE) {
    return 'Candidates anywhere in the U.S.';
  }
  const city = props.city?.trim();
  const state = props.state?.trim();
  const where = city && state ? `${city}, ${state}` : 'the job city';
  return `Candidates living within ${props.radiusMiles} miles of ${where}`;
});

function scrollToDescribeTheRole() {
  const section = document.getElementById(DESCRIBE_THE_ROLE_SECTION_ID);
  if (!section) return;
  const top = section.getBoundingClientRect().top + window.scrollY - SECTION_SCROLL_OFFSET;
  window.scrollTo({ top, behavior: 'smooth' });
}
</script>

<template>
  <div
    class="flex flex-col gap-2 rounded-xl bg-highlight-0 px-6 py-4 font-sans text-sm leading-[21px]"
  >
    <p class="text-shade-880">
      <span class="font-bold">Sourcing scope: </span>
      <span data-test="sourcing-scope-detail">{{ scopeDetail }}</span>
    </p>
    <p class="text-shade-800">No commute radius, since this role travels between job sites.</p>
    <button
      type="button"
      data-test="sourcing-scope-change-link"
      class="inline-flex items-center gap-0.5 font-bold leading-[21px] text-highlight-500"
      @click="scrollToDescribeTheRole"
    >
      Change in Describe the role
      <ArrowNarrowRightIcon class="h-5 w-5" aria-hidden="true" />
    </button>
  </div>
</template>
